"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actions = void 0;

require("core-js/modules/es6.regexp.to-string");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _moment = _interopRequireDefault(require("moment"));

var _logger = require("@/services/logger/logger.service");

var _helper = require("@/services/helper/helper.service");

var _milkRunV = require("@/api/milk-run-v2.api");

var logger = new _logger.Logger();
var helper = new _helper.Helper();
var actions = {
  setDateRange: function setDateRange(_ref, payload) {
    var commit = _ref.commit;
    commit('SET_START_DATE', payload['startDate']);
    commit('SET_END_DATE', payload['endDate']);
  },
  loadCoreInformation: function () {
    var _loadCoreInformation = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
      var commit, state, rootState, dispatch, milkRunV2API, res, trucks;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref2.commit, state = _ref2.state, rootState = _ref2.rootState, dispatch = _ref2.dispatch;
              milkRunV2API = new _milkRunV.MilkRunV2API({
                customerKey: rootState['authentication']['userInformation']['customerKey'] || null
              });
              _context.next = 4;
              return milkRunV2API.getTrucks({
                requestParameters: {
                  query: 'milkrun:1'
                }
              });

            case 4:
              res = _context.sent;

              if (!(!res || res.failed)) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return", false);

            case 7:
              trucks = helper.get(res, 'data', []);
              commit('SET_CORE_INFORMATION', [trucks]);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function loadCoreInformation(_x) {
      return _loadCoreInformation.apply(this, arguments);
    }

    return loadCoreInformation;
  }(),
  initPlan: function () {
    var _initPlan = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref3, pl) {
      var commit, state, rootState, dispatch, milkRunV2API, payload, isSortAsc, colName, sortStr, res, data, plan;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref3.commit, state = _ref3.state, rootState = _ref3.rootState, dispatch = _ref3.dispatch;
              milkRunV2API = new _milkRunV.MilkRunV2API({
                customerKey: rootState['authentication']['userInformation']['customerKey'] || null
              });
              payload = {
                startDate: state['planDateRange'][0] || (0, _moment.default)(new Date()).format('YYYY-MM-DD'),
                endDate: state['planDateRange'][1] || (0, _moment.default)(new Date()).format('YYYY-MM-DD')
              };

              if (!pl) {
                _context2.next = 16;
                break;
              }

              isSortAsc = pl.isSortAsc, colName = pl.colName;
              sortStr = '';
              _context2.t0 = colName;
              _context2.next = _context2.t0 === 'driverName' ? 9 : _context2.t0 === 'plateNumber' ? 11 : _context2.t0 === 'projectCode' ? 13 : 15;
              break;

            case 9:
              sortStr = 'driver.name';
              return _context2.abrupt("break", 15);

            case 11:
              sortStr = 'plateNumber';
              return _context2.abrupt("break", 15);

            case 13:
              sortStr = 'projectCode.0';
              return _context2.abrupt("break", 15);

            case 15:
              payload['sort'] = "".concat(sortStr, ":").concat(isSortAsc ? 'ASC' : 'DESC');

            case 16:
              if (state.selectedProjects.length > 0) {
                payload['projectCode'] = state.selectedProjects.toString();
              }

              if (state.selectedCustomers.length > 0) {
                payload['customerCode'] = state.selectedCustomers.toString();
              }

              if (state.selectedTrucks.length > 0) {
                payload['vehicleId'] = state.selectedTrucks.toString();
              }

              _context2.next = 21;
              return milkRunV2API.getPlan(payload);

            case 21:
              res = _context2.sent;

              if (!(!res || res.failed)) {
                _context2.next = 25;
                break;
              }

              commit('SET_TRUCK_LOADING', false);
              return _context2.abrupt("return", false);

            case 25:
              commit('SET_TRUCK_LOADING', false);
              data = helper.get(res, 'data', []);
              plan = {
                trucks: data
              };
              commit('SET_PLAN', plan);
              commit('SET_PLAN_EXISTS', true);
              logger.info('Get Saved Plan Object', plan);
              return _context2.abrupt("return", true);

            case 32:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function initPlan(_x2, _x3) {
      return _initPlan.apply(this, arguments);
    }

    return initPlan;
  }(),
  setPlan: function setPlan(_ref4, payload) {
    var commit = _ref4.commit,
        state = _ref4.state;
    var isReset = payload['isReset'];
    var plan = null;

    if (isReset) {
      plan = {
        planId: [],
        orders: [],
        trucks: []
      };
      logger.info('Get Initial Milk Run 2 Plan Object', plan);
    }

    commit('SET_PLAN', isReset ? plan : payload['plan']);
  },
  resetPlan: function resetPlan(_ref5) {
    var commit = _ref5.commit,
        rootState = _ref5.rootState;
    commit('SET_TRUCK_FILTERS', []);
    var truckId = null;
    commit('SET_SELECTED_TRUCK', truckId);
  }
};
exports.actions = actions;